module.exports = __webpack_public_path__ + "img/loadernew.b81bac6a.gif";